<template>
	<Wrapper background="tooltip" border-radius="4px">
		<Container :padding="8" :gap="8" direction="column">
			<Typography type="p3" color="light" weight="bold">
				{{ formatTitle(title) }}
			</Typography>
			<Container :padding="0" :gap="4" direction="column">
				<Container
					v-for="(p, index) in points"
					:key="p.index + p.name + index"
					align="space-between center"
					:padding="0"
				>
					<Typography type="p3" color="dark">
						{{ p.name }}
					</Typography>
					<Typography type="p3" color="dark" weight="bold">
						{{ p.value }}
					</Typography>
					<!-- <span class="flow-t-tooltip-point-value" :style="'color:' + p.color">{{ p.value }}</span> -->
				</Container>
			</Container>
		</Container>
	</Wrapper>
</template>
<script>
import { defineComponent } from "vue";
import moment from "moment";
import Typography from "./../../Typography/Typography";
import Container from "./../../Container/Container";
import Wrapper from "./../../Wrapper/Wrapper";

export default defineComponent({
	name: "SparklineTooltip",
	components: {
		Typography,
		Container,
		Wrapper
	},
	methods: {
		formatTitle(date) {
			return moment(date).format("DD-MM-YYYY | hh:mm:ss A");
		}
	}
});
</script>
<style lang="scss">
// div.flow-sparkline-tooltip {
// 	display: flex;
// 	flex-direction: column;

// 	background: rgba(0, 0, 0, 0.9);
// 	color: #fff;
// 	min-width: 200px;
// 	max-width: 300px;
// 	padding: 4px;
// 	font-family: inherit;
// 	font-size: 10px;
// 	border-radius: 4px;

// 	// > div.flow-t-tooltip-title {
// 	// 	display: flex;
// 	// 	align-items: center;
// 	// 	justify-content: flex-end;
// 	// 	font-size: 10px;
// 	// 	line-height: 10px;
// 	// 	margin-bottom: 4px;
// 	// }
// 	> div.flow-t-tooltip-name-value {
// 		display: flex;
// 		align-items: center;
// 		justify-content: space-between;

// 		> span.flow-t-tooltip-point-value {
// 			font-weight: bold;
// 			font-size: 14px;
// 			white-space: nowrap;
// 			line-height: 14px;
// 			margin-left: 16px;
// 		}
// 	}
// }
</style>
